import React from "react";
import LeadsContent from "../components/leads/leads-content";

const Leads = () => {
  return <LeadsContent />;
};

export default Leads;
